import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pega-pie-chart",
  "use": "pega-pie-chart-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pega-pie-chart\"><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M27.8 16.2h-12V4.3a1 1 0 00-1-.9 13.7 13.7 0 1014 13.7 1 1 0 00-1-1zM14.8 29A11.8 11.8 0 0114 5.3v11.8a1 1 0 001 1h12a12 12 0 01-12 10.9zM18 1.1V14h13A12.9 12.9 0 0018 1.1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol